// @flow

import React from 'react';
import PropTypes from 'prop-types';

import {makeStyles, Typography} from '@material-ui/core';

import addToCartImg from '../../../../../../assets/img/product-page/add-to-cart.png';
import {colors} from '../../../../../../assets/styles/colors';
import CustomModal from '../../../../../../elements/CustomModal/CustomModal';

import type {Theme} from '@material-ui/core';
type Props = {
  open: boolean,
  handleClose: () => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 360,
    maxWidth: '100%',
    padding: theme.spacing(4, 1, 2, 1),
    overflowX: 'hidden',
    [theme.breakpoints.up('md')]: {
      width: 600,
    },
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: '#313135',
  },
  text: {
    color: colors.grey800,
    fontSize: 16,
    fontWeight: 400,
  },
  imageWrap: {
    width: '100%',
    '& img': {
      maxWidth: '100%',
    },
  },
}));

export default function AddToCartModal(props: Props) {
  const {open, handleClose} = props;
  const classes = useStyles();

  return (
    <CustomModal
      open={open}
      handleCloseModal={handleClose}
      className={classes.modal}
    >
      <div className={classes.root}>
        <Typography className={classes.title} align="center" gutterBottom>
          Agregar al carrito
        </Typography>
        <Typography align="center" className={classes.text} gutterBottom>
          Flujo regular, cuando el comprador hace click al botón el producto
          carrito de compras se abre con el producto agregado. El comprador
          puede “Regresar a su compra” o proceder al pago haciendo click a
          “Comprar”.
        </Typography>

        <div className={classes.imageWrap}>
          <img src={addToCartImg} alt="add to cart" />
        </div>
      </div>
    </CustomModal>
  );
}

AddToCartModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
